export default function Contact({ language }) {

const isUrdu =
  language?.toLowerCase() === "ur" ||
  language?.toLowerCase() === "urdu";


return (
<div
style={{
padding: "50px 5%",
background: "#f5f5f5",
minHeight: "100vh",

}}
>

<h1
style={{
fontSize: "48px",
fontWeight: "700",
color: "#2e7f3c",
marginBottom: "40px",
textAlign: isUrdu ? "right" : "left",
}}
>
{isUrdu ? "اسٹور لوکیٹر" : "Store Locator"}
</h1>


<div
style={{
display: "flex",
gap: "30px",
flexWrap: "wrap",
alignItems: "flex-start",
}}
>


{/* Address Card */}

<div
style={{
flex: "1",
minWidth: "320px",
background: "#fff",
border: "1px solid #ddd",
padding: "30px",
boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
textAlign: isUrdu ? "right" : "left",
}}
>


<h2
style={{
marginBottom: "20px",
color: "#222",
}}
>
{isUrdu ? "پتہ" : "Address"}
</h2>



<p style={{fontSize:"18px", color:"#555"}}>

{isUrdu ? (
<>
📍 ڈائنامک سلوشنز، آفس 7،
<br/>
خورشید عالم روڈ،
<br/>
آر اے بازار بس اسٹیشن،
<br/>
لاہور، پاکستان
</>
) : (
<>
📍 Dynamic Solutions, Office 7,
<br/>
Khurshid Alam Road,
<br/>
RA Bazaar Bus Station,
<br/>
Lahore, Pakistan
</>
)}

</p>



<p
style={{
marginTop:"20px",
fontSize:"18px"
}}
>
📞 +92 317 0845855
</p>



<p
style={{
marginTop:"10px",
fontSize:"18px"
}}
>
📧 sales.dynmsol@gmail.com
</p>




<p
style={{
marginTop:"25px",
lineHeight:"1.8",
color:"#666",
}}
>

{
isUrdu
?
"آرڈرز، ہول سیل معلومات یا کسٹمر سپورٹ کے لیے کسی بھی وقت ہم سے رابطہ کریں۔"
:
"Feel free to contact us anytime for orders, wholesale inquiries, or customer support."
}

</p>


</div>




{/* Right Side */}

<div
style={{
  flex:"1.5",
  minWidth:"550px",
  height:"400px",
  background:"#fff",
  border:"1px solid #ddd",
  overflow:"hidden",
}}
>

<iframe
title={isUrdu ? "مقام کا نقشہ" : "Location Map"}

src={
isUrdu
?
"https://www.google.com/maps?q=Dynamic%20Solutions%20Office%207%20Khurshid%20Alam%20Road%20RA%20Bazaar%20Bus%20Station%20Lahore%20Pakistan&output=embed&hl=ur"
:
"https://www.google.com/maps?q=Dynamic%20Solutions%20Office%207%20Khurshid%20Alam%20Road%20RA%20Bazaar%20Bus%20Station%20Lahore%20Pakistan&output=embed&hl=en"
}

width="100%"
height="100%"
style={{
  border:0,
}}

loading="lazy"
allowFullScreen
>
</iframe>

</div>


</div>

</div>

)

}